module.exports = __webpack_public_path__ + "static/img/silver.92f875d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/silver.png
// module id = PuIy
// module chunks = 35